import React, { useEffect, useId, useRef, useState } from 'react';
import { LuGem, LuInfo, LuLogOut } from 'react-icons/lu';
import { logout } from '../utils/logout';
import AboutModal from './AboutModal';
import PlanIndicator from './PlanIndicator';
import '../styles/Header.css';

const COPY = {
  ja: { account: 'アカウントメニュー', plans: 'プラン管理', about: 'このアプリについて', logout: 'ログアウト' },
  en: { account: 'Account menu', plans: 'Plans', about: 'About this app', logout: 'Log out' },
};

export default function AccountMenu({ user, locale, isPro, isLoadingPlan, compact = false }) {
  const [open, setOpen] = useState(false);
  const [aboutOpen, setAboutOpen] = useState(false);
  const ref = useRef(null);
  const trigger = useRef(null);
  const id = useId();
  const text = COPY[locale] || COPY.en;
  useEffect(() => {
    if (!open) return;
    ref.current?.querySelector('[role="menuitem"]')?.focus();
    const outside = (event) => { if (!ref.current?.contains(event.target)) setOpen(false); };
    const escape = (event) => {
      if (event.key === 'Escape') { setOpen(false); trigger.current?.focus(); }
    };
    document.addEventListener('mousedown', outside);
    document.addEventListener('keydown', escape);
    return () => { document.removeEventListener('mousedown', outside); document.removeEventListener('keydown', escape); };
  }, [open]);
  const focusItem = (event) => {
    if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const items = [...ref.current.querySelectorAll('[role="menuitem"]')];
    const index = items.indexOf(document.activeElement);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1
      : (index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
    items[next]?.focus();
  };
  return (
    <>
      <div className={`profile-menu-container account-menu${compact ? ' account-menu--compact' : ''}`} ref={ref}>
        <button type="button" className="profile-menu-trigger" ref={trigger} aria-label={text.account}
          aria-haspopup="menu" aria-expanded={open} aria-controls={open ? id : undefined}
          onClick={() => setOpen((value) => !value)}>
          <img src={user.picture || user.photoURL || '/logo192.png'} alt="" className="user-avatar" />
          <span className="header-plan-pill"><PlanIndicator isLoading={isLoadingPlan} isPro={isPro} locale={locale} /></span>
        </button>
        {open && (
          <div className="profile-menu-dropdown" id={id} role="menu" aria-label={text.account} onKeyDown={focusItem}>
            <a className="profile-menu-item" role="menuitem" href="/upgrade" onClick={() => setOpen(false)}><LuGem className="profile-menu-icon" aria-hidden="true" /><span>{text.plans}</span></a>
            <button type="button" className="profile-menu-item" role="menuitem" onClick={() => { setOpen(false); setAboutOpen(true); }}><LuInfo className="profile-menu-icon" aria-hidden="true" /><span>{text.about}</span></button>
            <button type="button" className="profile-menu-item profile-menu-item--logout" role="menuitem" onClick={() => { setOpen(false); logout(); }}><LuLogOut className="profile-menu-icon" aria-hidden="true" /><span>{text.logout}</span></button>
          </div>
        )}
      </div>
      <AboutModal isOpen={aboutOpen} onClose={() => setAboutOpen(false)} locale={locale} />
    </>
  );
}
